import { get, put,Delete,post } from '../axios'

// 用户列表-列表
export const manageList = params => get(`/web/user/manage/list`,params);

// 用户列表-新增
export const manageAdd = params => post(`/web/user/manage/add`,params);

// banner-删除
export const managemDelete = params => Delete('/web/user/manage/delete/' + params.id, '');

// 用户列表-批量删除
export const managemDeletes = params => Delete('/web/user/manage/deletes/' + params.id, '')

// //banner-查看
// export const pcView = params => get('/web/lanxin/url/view/' + params.id, '');

// 用户列表-编辑
export const manageUpdate = params => put(`/web/user/manage/update`,params);

//用户列表-设为会员
export const manageSetVip = params => post(`/web/user/manage/add/vip`,params);

